import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { TOKEN_KEY } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { HeroMark } from "@/components/Logo";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate("/auth"); return; }
      try {
        const res = await api.post("/auth/google/session", { session_id: sessionId });
        if (res.data?.token) localStorage.setItem(TOKEN_KEY, res.data.token);
        if (res.data?.user) setUser(res.data.user);
        // clean the hash and go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        setError("We couldn't complete your Google sign-in. Please try again.");
        setTimeout(() => navigate("/auth"), 2200);
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="starfield-wrap min-h-screen flex items-center justify-center bg-[#070815]">
      <div className="starfield" aria-hidden="true" />
      <div className="relative z-10 text-center">
        <HeroMark className="mx-auto" />
        {error ? (
          <p className="mt-4 text-[#FB7185]">{error}</p>
        ) : (
          <div className="mt-4 flex items-center justify-center gap-2 text-secondary-cosmic">
            <Loader2 className="animate-spin text-[#22D3EE]" size={18} /> Beaming you aboard…
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
